export default __webpack_public_path__ + "ea9a5f82f6f2c127a52df658ecb12406.svg";